import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b02400c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["set"]
const _hoisted_7 = ["onClick", "onMouseover", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", {
    class: _normalizeClass({
      mayCollapse: _ctx.state.playerAllowedCollapses >= 1,
      player1: _ctx.state.next_player,
    })
  }, [
    _createElementVNode("tr", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.width, (column) => {
        return (_openBlock(), _createElementBlock("th", { key: column }, [
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.placeColor(column)),
            class: "color"
          }, "Color", 8, _hoisted_2),
          (!_ctx.state.colorPiece)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.placeClassical(column)),
                  class: "classic"
                }, " Classic ", 8, _hoisted_3),
                (_ctx.preparedColumn === undefined)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.prepare(column)),
                      class: "space"
                    }, " Space 1st ", 8, _hoisted_4))
                  : (_ctx.preparedColumn != column)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.placeSpace(column)),
                        class: "space"
                      }, " Space 2nd ", 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.preparedColumn = undefined)),
                        class: "reset"
                      }, " Reset "))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.height, (row) => {
      return (_openBlock(), _createElementBlock("tr", { key: row }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.width, (column) => {
          return (_openBlock(), _createElementBlock("td", {
            key: column,
            set: (_ctx.col = _ctx.state.occupancyCache[column]?.[row]),
            class: _normalizeClass({ empty: _ctx.col === undefined })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.col, (piece) => {
              return (_openBlock(), _createBlock(_Transition, {
                key: piece.id,
                name: "slide",
                appear: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({
                small: !piece.stable,
                player1:
                  // no color superposition ~> use piece player
                  (piece.player1 && piece.colorPieceOther === undefined) ||
                  // color superposition and one of the options is hovered
                  (piece.colorPieceOther !== undefined &&
                    piece.colorID === _ctx.highlight?.piece?.colorID &&
                    // then highlight hovered piece in next player color
                    !((piece === _ctx.highlight.piece) ^ _ctx.state.next_player)),
                color:
                  piece.colorID !== undefined &&
                  // no highlighting when 2nd piece missing (i.e. when colorPieceOther = undefined)
                  (piece.colorPieceOther === undefined ||
                    piece.colorID !== _ctx.highlight?.piece?.colorID),
                highlight:
                  // non-color non-stable is highlighted ~> highlight pieces in resulting remaining worlds
                  !piece.stable &&
                  _ctx.highlightOccupancy[column]?.[row]?.has(piece),
                highlightColor:
                  // part of highlighted color superposition piece
                  piece.colorPieceOther !== undefined &&
                  piece.colorID === _ctx.highlight?.piece?.colorID,
                winning: _ctx.state.winner?.pieces?.has(piece),
              }),
                    onClick: ($event: any) => (_ctx.collapse(column, row, piece)),
                    onMouseover: ($event: any) => (
                _ctx.highlight = { column: column, row: row, piece: piece }
              ),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.highlight = undefined)),
                    title: _ctx.getPieceActionHint(piece) + _ctx.getActionPieceDebug(piece)
                  }, _toDisplayString(piece.id), 43, _hoisted_7)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ], 10, _hoisted_6))
        }), 128))
      ]))
    }), 128))
  ], 2))
}